<template>
  <div class="bg-background-neutral-secondary rounded-xl px-4 pb-0.5">
    <h3
      v-if="groupLetter"
      class="text-text-neutral-quaternary pt-4 text-xs font-medium"
    >
      {{ groupLetter }}
    </h3>
    <ul
      class="text-text-neutral-secondary divide-situational-lightgrey divide-y"
    >
      <li v-for="citizenship in countriesList" :key="citizenship.code">
        <button
          type="button"
          class="flex w-full justify-between py-4 text-base"
          :class="{
            'text-text-positive-primary': isSelectedCountry(citizenship.code),
          }"
          @click="handleCitizenshipSelect(citizenship)"
        >
          <p class="text-left font-semibold">
            {{ getLocalizedCountryName(citizenship) }}
          </p>
          <p class="font-medium">{{ citizenship.code }}</p>
        </button>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
  import { citizenshipEntity } from 'shared';

  const props = defineProps<{
    selectedCountryCode: string;
    countriesList: citizenshipEntity.types.Country[];
    groupLetter?: string;
  }>();

  const emit = defineEmits<{
    onCitizenshipSelect: [citizenshipCode: string];
  }>();

  const isSelectedCountry = (countryCode: string) =>
    countryCode === props.selectedCountryCode;
  const getLocalizedCountryName = (
    citizenship: citizenshipEntity.types.Country,
  ) => {
    return citizenshipEntity.lib.getLocalizedCountryName(citizenship);
  };

  const handleCitizenshipSelect = (
    citizenship: citizenshipEntity.types.Country,
  ) => {
    emit('onCitizenshipSelect', citizenship.code);
  };
</script>
